export default {
feedback: {
  title: "피드백",
  placeholder: "메시지를 입력하세요 ({ contentLen }/1000자)",
  error: "오류 메시지입니다",
  uploadLimit: "이미지 및 동영상 업로드 제한",
  send: "전송",
  tipTitle: "더 나은 경험을 위해 도와주세요",
  desc1: "문의사항을 제출할 수 있으며, 채택되면 깜짝 선물을 받게 됩니다.",
  desc2: "웹사이트 이용이 불편할 경우 이메일로도 제출할 수 있습니다."
}
};
